"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.datadogBrowser = void 0;
const api_client_1 = require("./api-client");
const metrics_buffer_1 = require("./metrics-buffer");
const DEFAULT_FLUSH_INTERVAL = 500; // Every half second
const DEFAULT_PROXY_URL = 'https://api.glovoapp.com/frontend_metrics/metrics';
const DEFAULT_BUFFER_SIZE = 100; // Each metric is around 150B, So we are aiming to a max of 15KB
function datadogBrowser({ proxyUrl = DEFAULT_PROXY_URL, flushInterval = DEFAULT_FLUSH_INTERVAL, bufferSize = DEFAULT_BUFFER_SIZE, logger = console, } = {}) {
    const buffer = (0, metrics_buffer_1.makeMetricsBuffer)(bufferSize);
    const api = (0, api_client_1.makeApiClient)({ proxyUrl });
    const sendMetricsTimer = setInterval(sendMetricsBatch, flushInterval);
    function sendMetricsBatch() {
        return __awaiter(this, void 0, void 0, function* () {
            buffer.prune();
            if (buffer.isEmpty()) {
                return;
            }
            const metricsToSend = buffer.values();
            buffer.flush();
            try {
                yield api.send(metricsToSend);
            }
            catch (err) {
                const logEntity = err instanceof Error ? err : JSON.stringify(err);
                logger.warn('DD_BROWSER_METRICS', logEntity);
                // NOTE: The api does not provide granularity if a single metric failed, hence we re-buffer all of them
                metricsToSend.forEach((metric) => {
                    buffer.add(metric);
                });
            }
        });
    }
    return {
        send(metric) {
            try {
                if (sendMetricsTimer) {
                    buffer.add(metric);
                    if (buffer.isFull()) {
                        sendMetricsBatch();
                    }
                }
            }
            catch (e) {
                const logEntity = e instanceof Error ? e : JSON.stringify(e);
                logger === null || logger === void 0 ? void 0 : logger.warn('DD_BROWSER_METRICS', logEntity);
            }
        },
        clear() {
            if (sendMetricsTimer) {
                clearInterval(sendMetricsTimer);
            }
        },
    };
}
exports.datadogBrowser = datadogBrowser;
//# sourceMappingURL=index.js.map